// extracted by mini-css-extract-plugin
export default {"wrapButtonFooter":"add-company-modal_wrapButtonFooter__oGbuW"};